// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a590ff58","453":"c0c3ab09","934":"d588c65b"}[chunkId] + ".chunk.js";
};